/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useMemo } from 'react';
import DatePicker from './DatePicker';
import { getMinDate } from '../../../shared/utils/dateUtils';

export default function DatePickerPast(props) {
  const {
    schema: { maxPastMonths },
    uiSchema,
    schema,
    onChange,
    id,
    registry,
  } = props;

  const _onChange = (date) => {
    if (uiSchema?.['ui:options']?.triggerPostProcess === true || schema?.config?.triggerPostProcess === true) {
      registry.triggerPostProcess(id, date);
    }
    onChange(date);
  };

  const minDate = useMemo(() => {
    return getMinDate(maxPastMonths);
  }, [maxPastMonths]);

  return <DatePicker disableFuture fullWidth minDate={minDate} {...props} onChange={_onChange} />;
}
